<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des environnements"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/environment/list"
                :searchArgs="searchArgs">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/environment"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'environnement')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet environnement?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../components/DynamicCardList'
    import ModalTrash from '../components/ModalTrash'
    export default {
        name: 'EnvironmentList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom'),
                        key: 'name',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Sous-domaine'),
                        key: 'subDomain',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Forfait'),
                        key: 'plan',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        type: 'date',
                        sortable: true
                    },
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'name'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'status'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'plan'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                        },
                        {
                            id: 'name',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom')
                        },
                        {
                            id: 'status',
                            type: 'select',
                            label: Core.Definition.getDefinition('État'),
                            onSelect: function() {}
                        },
                        {
                            id: 'plan',
                            type: 'select',
                            label: Core.Definition.getDefinition('Forfait'),
                            onSelect: function() {}
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/plateforme/environnements/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
